module.exports = __webpack_public_path__ + "static/img/4.7c5fac1b.png";